import React, { FC, useMemo } from 'react';
import clsx from 'clsx';
import { Icon } from '@npm-registry/eapteka-ui';
import {
  TCustomTooltipSides,
  TCustomTooltip
} from './types';
import { TOOLTIP_SIDE_CLASS_MAP } from './consts';
import styles from './Tooltip.scss';

export const Tooltip: FC<TCustomTooltip> = ({
  className,
  content,
  iconName = 'infoRound',
  style,
  side = TCustomTooltipSides.right
}) => {
  const isTooltipVisible = !!content;
  const rootClassNames = useMemo(
    () =>
      clsx(styles.root, className, {
        [styles.rootHasInfo]: isTooltipVisible
      }),
    [isTooltipVisible, className]
  );

  return (
    <span className={rootClassNames}>
      <span className={styles.container}>
        <Icon
          size="s"
          name={iconName}
          className={styles.icon}
          style={style}
        />
      </span>
      {isTooltipVisible && (
        <b
          className={clsx(
            styles.description,
            TOOLTIP_SIDE_CLASS_MAP[side]
          )}
        >
          {content}
        </b>
      )}
    </span>
  );
};
